import { useCallback, useEffect, useRef } from "react";
import { getDiscountsByDivision } from "../utils/shopGridDiscounts";

export const useDiscountOptions = ({ discountsValues, discountsLoading, discountsLoadError }) => {
  const discountsOptionsCacheRef = useRef(new Map());

  useEffect(() => {
    discountsOptionsCacheRef.current = new Map();
  }, [discountsValues]);

  const getDiscountOptionsForElement = useCallback(
    (divisionId, sku) => {
      if (!Number.isFinite(Number(divisionId))) {
        return { options: [], placeholder: "Divisione non valida", disabled: true };
      }
      if (discountsLoadError) {
        return { options: [], placeholder: "Configurazione sconti non disponibile", disabled: true };
      }
      if (discountsLoading || !discountsValues) {
        return { options: [], placeholder: "Caricamento sconti…", disabled: true };
      }

      const cacheKey = `${divisionId}|${typeof sku === "undefined" || sku === null ? "" : String(sku)}`;
      if (discountsOptionsCacheRef.current.has(cacheKey)) {
        return discountsOptionsCacheRef.current.get(cacheKey);
      }

      const values = getDiscountsByDivision(discountsValues, divisionId, sku);
      const options = values.map((v) => ({ value: v, label: `${v}%` }));
      const result = {
        options,
        placeholder: options.length > 0 ? "Seleziona uno sconto" : "Nessuno sconto disponibile",
        disabled: options.length === 0,
      };
      discountsOptionsCacheRef.current.set(cacheKey, result);
      return result;
    },
    [discountsLoadError, discountsLoading, discountsValues]
  );

  return { getDiscountOptionsForElement };
};

